// Bound tab-local bookkeeping. Evicted sources may require recovery or approval in Chat.
const MAX_LOCAL_SOURCES = 20;

// Shared by the save handler and later approval mounts; a hook-local ref would lose that link.
// These IDs correlate requests, not authorize actions. A reload or duplicate module instance can
// lose the association; Chat still validates the session and falls back when it cannot recover.
const sourceIdsByComment = new Map<string, string>();

/** Keeps this tab's recent invocation and recovered approval sources; it is not persisted. */
export const registerBackgroundConversationSource = (commentId: string): string => {
	const sourceId = crypto.randomUUID();
	sourceIdsByComment.delete(commentId);
	sourceIdsByComment.set(commentId, sourceId);
	if (sourceIdsByComment.size > MAX_LOCAL_SOURCES) {
		sourceIdsByComment.delete(sourceIdsByComment.keys().next().value as string);
	}
	return sourceId;
};

export const getBackgroundConversationSource = (commentId: string): string | undefined =>
	sourceIdsByComment.get(commentId);

export const clearBackgroundConversationSourcesForTests = (): void => sourceIdsByComment.clear();
